/**
 * api/auth.ts —— 认证接口（§五 5.1）
 *
 * ⚠ 登录查 oaAccount，【不是工号 empNo】——2026-09-09 起两者同值（账号口径 = 员工编号），
 *   但接口出入参只认 oaAccount，别改成传 empNo。
 *   这一条 2026-08-05 管理员当面更正过，写错了所有人都登不进来。
 * ⚠ 密码只在入参里出现一次，不存 state、不写 sessionStorage、不进日志。
 */
import { get, post, put, type ReqOptions } from './client.js';
import type { AuthUser } from '@shared-types';

export const login = (oaAccount: string, password: string) =>
  post<AuthUser>('/api/auth/login', { oaAccount, password });

export const logout = () => post<{ ok: boolean }>('/api/auth/logout');

/**
 * 当前登录用户。
 * ⚠ boot 阶段调用时【必须传 quiet401】——那时未登录是正常结果，
 *   不传会触发 onUnauthorized 跳登录页，与 boot 自己的跳转打架。
 */
export const me = (opts?: ReqOptions) => get<AuthUser>('/api/auth/me', opts);

/**
 * 改密（唯一一条）。⚠ 必须报上当前密码——2026-08-26 删掉了首登专用的免旧密码接口。
 * 登录页的自助改密入口也走它：先 login 拿一次会话，再 PUT，最后 logout。
 */
export const changePassword = (oldPassword: string, newPassword: string) =>
  put<{ ok: boolean }>('/api/auth/password', { oldPassword, newPassword });

/** 管理员重置。⚠ 出参里的初始密码只在这一次响应里出现，不存不发（§五 5.1） */
export const resetPassword = (personId: string) =>
  post<{ initialPassword: string }>('/api/auth/password/reset', { personId });
